import {
  EnvironmentProviders,
  Injectable,
  InjectionToken,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

export const APP_VERSION = new InjectionToken<string>('app-version');
export const GIT_HASH = new InjectionToken<string>('git-hash');

interface BuildJson {
  version: string;
  git: string;
}

@Injectable({ providedIn: 'root' })
export class VersionService {
  version = '';
  git = '';

  async load() {
    try {
      const res = await fetch('/build.json', { cache: 'no-cache' });
      if (!res.ok) return;
      const data = (await res.json()) as BuildJson;
      this.version = data.version;
      this.git = data.git;
    } catch {
      // Silently ignore — build.json may not exist during local development.
    }
  }
}

/**
 * Provides `APP_VERSION` and `GIT_HASH` tokens by fetching `/build.json`
 * at application startup. If the file is unavailable (e.g. during local
 * development), tokens resolve to empty strings.
 */
export function provideAppVersion(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(VersionService).load()),
    {
      provide: APP_VERSION,
      useFactory: (svc: VersionService) => svc.version,
      deps: [VersionService],
    },
    {
      provide: GIT_HASH,
      useFactory: (svc: VersionService) => svc.git,
      deps: [VersionService],
    },
  ]);
}
